import React, {useEffect, useState} from 'react';
import { observer } from "mobx-react";
import { JackpotWidgetAspectRatioBox } from '../jackpot-widget/boxes/aspect-ratio/jackpot-widget-aspect-ratio.box';
import { JackpotWidgetBox } from '../jackpot-widget/boxes/jackpot-widget.box';
import { JACKPOT_WIDGET_LAYOUT } from '../jackpot-widget/jackpot-widget.component';
import { Check } from '@sparkware/app-utils';
import { useServices } from '../../react-hooks/use-services.hook';
import {JackpotBetWidgetGamesListContainerBox} from "./boxes/games-list-container-box/jackpot-bet-widget-games-list-container.box";
import {
    GameImageContainerComponent
} from "../single-game/common/parts/game-image-container.component/game-image-container.component";
import {
    GameImageContainerBox
} from "../single-game/regular-template/boxes/game-image-container/game-image-container.box";
import {GameInfo, OpenGameParameters} from "../../services/games/game-info";
import {JackpotBetWidgetGamesListBox} from "./boxes/jackpot-bet-widget-games-list.box";
import {JackpotBetWidgetContentBox} from "./boxes/jackpot-bet-widget-content.box";
import {JackpotBetWidgetGameFlexContainerBox} from "./boxes/jackpot-bet-widget-game-flex-container.box";
import {JackpotBetWidgetBgBox} from "./boxes/background-box/jackpot-bet-widget-bg.box";
import {JackpotBetWidgetGradientTextBox} from "./boxes/gradient-text-box/jackpot-bet-widget-gradient-text.box";
import {JackpotBetWidgetGradientBackgroundTextBox} from "./boxes/gradient-background-text-box/jackpot-bet-widget-gradient-background-text.box";
import {JackpotBetWidgetPrizeComponent} from "./jackpot-bet-widget-prize/jackpot-bet-widget-prize.component";
import {
    JackpotBetWidgetConfiguration
} from "../../services/configurations/config-data-sections/jackpot-bets-widget.configuration";
import {JackpotBetWidgetHighlightedTextBox} from "./boxes/highlighted-text-box/jackpot-bet-widget-highlighted-text.box";
import {JackpotBetWidgetShadowOverlayBox} from "./boxes/shadow-overplay-box/jackpot-bet-widget-shadow-overlay.box";
import {JackpotBetWidgetLogoBox} from "./boxes/logo-box/jackpot-bet-widget-logo.box";
import {JpbWidgetMainTextContainerBox} from "./boxes/main-text-container/jpb-widget-main-text-container.box";


interface JackpotBetWidgetComponentProps {
    WrapperBox?: React.ComponentType;
    widgetConfig: JackpotBetWidgetConfiguration;
    gameTypes?: number[];
    useSquareIcons?: boolean;
    listName?: string;
    arenaName?: string;
}

const ComponentBody: React.FC<JackpotBetWidgetComponentProps> = observer((props) => {
    const services = useServices();
    const [currentIndex, setCurrentIndex] = useState(0);

    const availablePrizes = services.jackpotBet.jackpotsInfo.getPrizes().filter(prize => Boolean(prize));

    useEffect(() => {
        let interval: any;
        if(availablePrizes.length > 0) {
            interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % availablePrizes.length);
            }, 5000); // Change the displayed jackpot every 5 seconds
        }

        return () => {
            if(interval) {
                clearInterval(interval);
            }
        }
    }, [availablePrizes.length, services.jackpotBet]);



    if (availablePrizes.length === 0) {
        return null;
    }

    const currentPrize = availablePrizes[currentIndex];

    const getJackpotWidgetLayout = (): JACKPOT_WIDGET_LAYOUT => {
        const isMobileTablet = services.mediaQuery.mAndAbove && services.mediaQuery.lAndBelow;

        return isMobileTablet ? JACKPOT_WIDGET_LAYOUT.PORTRAIT_TALL : JACKPOT_WIDGET_LAYOUT.PORTRAIT;
    }

    const getCurrentJackpotAmount = (): string => {
        const amount = availablePrizes[currentIndex].amount;
        return services.currency.formatMoney(amount, true);
    }

    const getWinsTodayText = (): string => {
        //const sum = services.jackpotBet.jackpotsInfo.totalWinsToday;
        const sum = services.jackpotBet.jackpotsInfo.animatedTotalWinsToday;
        return services.currency.formatMoney(sum);
    }

    const renderGames = (): React.ReactNode => {
        if (Check.isEmpty(props.gameTypes)) {
            return null;
        }

        const openGame = async (gameInfo: GameInfo) => {
            const openGameParams: OpenGameParameters = {
                isRealMode: true,
                listTitle: props.listName,
                pageName: props.arenaName
            };
            await gameInfo.open(openGameParams)
        }

        //Slice 0, 10 because product wants us to only show 10 games on mobile regardless of admin config. Mb move this in model?
        return (
            <>
                <div>
                    {services.translation.translate("JACKPOT_BET_AVAILABLE_GAMES")}
                </div>
                <JackpotBetWidgetGamesListBox className={'cy-jackpot-bet-mobile-game-list'}>
                    {props.gameTypes.slice(0, 10).map(gameType => {
                        const gameInfo = services.games.gamesMap[gameType];

                        if (!gameInfo) {
                            return null;
                        }

                        return (
                            <JackpotBetWidgetGameFlexContainerBox>
                                <GameImageContainerComponent gameInfo={gameInfo}
                                                             box={GameImageContainerBox}
                                                             onOpenRealGame={() => openGame(gameInfo)}
                                                             useSquareIcons={Boolean(props.useSquareIcons)}
                                                             playRealGameButton={null}
                                />
                            </JackpotBetWidgetGameFlexContainerBox>
                        );
                    })}
                </JackpotBetWidgetGamesListBox>
            </>
        );
    }

    const renderJackpotWidgetContent = (): React.ReactNode => {
        return (
            <JackpotBetWidgetContentBox>
                <JpbWidgetMainTextContainerBox>
                    <JackpotBetWidgetGradientTextBox>
                        {services.translation.translate("JACKPOT_BET_WINNERS_TODAY")}
                    </JackpotBetWidgetGradientTextBox>
                    <JackpotBetWidgetGradientBackgroundTextBox className={'cy-jp-bets-widget-winners-count'}>
                        <JackpotBetWidgetHighlightedTextBox>
                            {services.jackpotBet.jackpotsInfo.winnersCount}
                        </JackpotBetWidgetHighlightedTextBox>
                    </JackpotBetWidgetGradientBackgroundTextBox>
                    <JackpotBetWidgetGradientTextBox>
                        {services.translation.translate("JACKPOT_BET_WON_TODAY")}
                    </JackpotBetWidgetGradientTextBox>
                    <JackpotBetWidgetGradientBackgroundTextBox className={'cy-jp-bets-widget-wins-today'}>
                        <JackpotBetWidgetHighlightedTextBox>
                            {getWinsTodayText()}
                        </JackpotBetWidgetHighlightedTextBox>
                    </JackpotBetWidgetGradientBackgroundTextBox>
                </JpbWidgetMainTextContainerBox>
                <JackpotBetWidgetGamesListContainerBox shouldHaveNoBackground={Check.isEmpty(props.gameTypes)}>
                    <JackpotBetWidgetPrizeComponent prizeLabel={currentPrize.label} amount={getCurrentJackpotAmount()}/>
                    {renderGames()}
                    <JackpotBetWidgetShadowOverlayBox/>
                </JackpotBetWidgetGamesListContainerBox>
            </JackpotBetWidgetContentBox>
        );

    }

    if (!props.widgetConfig?.display) {
        return null;
    }

    const WrapperBox = props.WrapperBox || React.Fragment;
    return (
        <WrapperBox>
            <JackpotWidgetAspectRatioBox layout={getJackpotWidgetLayout()}>
                <JackpotWidgetBox className="cy-jackpot-widget">
                    <JackpotBetWidgetBgBox layout={getJackpotWidgetLayout()}>
                        <JackpotBetWidgetLogoBox/>
                        {renderJackpotWidgetContent()}
                    </JackpotBetWidgetBgBox>
                </JackpotWidgetBox>
            </JackpotWidgetAspectRatioBox>
        </WrapperBox>
    );
});

export const JackpotBetWidgetComponent = ComponentBody;